import { UserRegistrationStatus } from 'UserRegistration/resources/utils/UserRegistrationStatus';


/**
 * Method used for generating the default registration data context for production and tests.
 * Tests that need specific values changed will need to modify the context manually afterwards.
 * 
 * @param {string} context the current context of the application, such as ADD_CONTACT
 * @returns {object} the default initial data context of the application.
 */
export function createInitialRegistrationDataState(context, furtherOffersDefaultValue) {
    return {
        // The entered credit card information.
        creditCardInfo: {
            type: null,
            lastFourDigits: null,
            termsAndConditions: null,
            termsAndConditionsAccepted: false,
            mpgCardType: null,
            cardHolderName: null,
            cardNumber: null,
            expirationMonth: null,
            expirationYear: null,
            securityCode: null
        },
        metadata: {
            // The step that the user has reached.
            currentStep: 1,
            // Number of failed submission attempts for this form
            formSubmissionFailures: 0,
            // Flag that indicates whether or not billing information is required from the user. This should normally always be true unless if a user selects a free package (only available in certain contexts).
            isBillingRequired: true,
            // Is the page currently in the process of submitting a form?
            isSubmitting: false,
            /* 
                status : 
                DRAFT: Starting Status
                CONTACT_CREATED: Contact has been created and persisted in the database
                MAC_SYNC_COMPLETE: Mac has received the information and generated a MAC ID
                MAC_SYNC_ERROR: Mac failed to sync the information and could not generate a MAC ID
                CONTRACT_CREATION_ERROR, Contract could not be created in MAC, have the user communicate with customer service
                ACTIVATION_ERROR: Account could not be activated, but billing will have taken place, have the user communicate with customer service
                COMPLETED: Everything went well. 
            */
            status: UserRegistrationStatus.DRAFT,
            // The frequency selected by the user.
            userSelectedFrequency: null,
        },
        // Tax and discount pricing data for the currently selected options.
        priceTaxesInfo: {
            orderedPackage: null,
            taxes: [],
            subTotal: 0,
            total: 0,
            totalBeforeTaxes: 0,
            discountAmount: 0,
            discountPercentage: 0,
            recurringSubTotal: 0,
            promoDiscountAmount: 0
        },
        // This registrationModel is what will be submitted to the server for create and updates.
        registrationModel: {
            // The currently selected subscription package data.
            selectedSubscriptionPackage: null,
            selectedSecondarySubscriptions: [],
            wasSecondarySubscriptionModified: false,
            userRegistrationId: null,
            recaptchaToken: null,
            registrationContext: context,
            promotion: {
                id: null,
                code: null,
                description: null,
                type: null,
                amount: null
            },
            subscription: {
                vasItemIds : [],
                vasRemovedIds: [],
                selectedFrequency: null,
                selectedGroup: {
                    groupId: null,
                    groupKey: null,
                    description: null,
                    cmsKey: null,
                    selectedSubscriptionItemDescription: null,
                    selectedSubscriptionItemIds: [],
                    selectedSubscriptionAssociatedItemKeys: []
                }
            },
            personalInformation: {
                userFirstName: null,
                userLastName: null,
                emailAddress: null,
                phoneNumber: null,
                username: null,
                emailUsername: null,
                password: null,
                confirmPassword: null,
                organizationName: null,
                termsAndConditionsAccepted: false,
                receiveFurtherOffers: furtherOffersDefaultValue
            },
            roleSelection: {
                selectedRoleIds: []
            },
            billingInformation: {
                address: null,
                countryId: null,
                stateProvinceId: null,
                city: null,
                zipCode: null,
                selectedPayWithNewCard: true,
                existingCCType: null,
                existingCCLastFourDigits: null
            },
            informations: []
        },
        preSelectedSubItemAssociatedKey: null,
        // This map contains the currently selected subscription items (map of arrays) in each of the dropdowns for each of the packages. Key = group.description
        selectedSubscriptionItems: [],
        // Validation errors that may be returned by the server upon form validation.
        validationErrors: [],
        // items to include in the invoice
        invoiceItemIDs: [],
        // boolean to disable adding EAP to registration when user manually adds EAP.
        eapLinkDisabled: false
    }
}
